import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced, getBackgroundImages, getVerticalAlignment, getMediaQueries } from '../../utils';
export default (function (node) {
  return _objectSpread({
    tabName: node.getAttribute('data-tab-name'),
    minHeight: node.style.minHeight
  }, getVerticalAlignment(node), {
    backgroundColor: node.style.backgroundColor
  }, getBackgroundImages(node), getAdvanced(node), getMediaQueries(node));
});